import React from "react";
import { Flex } from "theme-ui";
import { OverallProps, ReviewProps } from "../TrustPilot";
import Star from "./Star";

const Stars = (props: OverallProps | ReviewProps) => {
  let { rating, size } = props;
  const isFloat = !Number.isInteger(rating);
  isFloat ? (rating = rating - 1) : rating;
  const halfStarIndex = Math.round(rating);

  return (
    <Flex
      sx={{
        width: "fit-content",
      }}
    >
      {Array(5)
        .fill("star")
        .map((s, i) => (
          <Star
            key={i}
            size={size ? size : 30}
            full={i < rating ? true : false}
            half={isFloat && i == halfStarIndex ? true : false}
            color="#00b67a"
          />
        ))}
    </Flex>
  );
};

export default Stars;
